import React, { Fragment } from 'react';

import { Grid } from '@material-ui/core';

export default function LivePreviewExample() {
  return (
    <Fragment>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-warm-flame" />
            <h6 className="color-swatch--title">bg-warm-flame</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-night-fade" />
            <h6 className="color-swatch--title">bg-night-fade</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-tempting-azure" />
            <h6 className="color-swatch--title">bg-tempting-azure</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-sunny-morning" />
            <h6 className="color-swatch--title">bg-sunny-morning</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-heavy-rain" />
            <h6 className="color-swatch--title">bg-heavy-rain</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-amy-crisp" />
            <h6 className="color-swatch--title">bg-amy-crisp</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-malibu-beach" />
            <h6 className="color-swatch--title">bg-malibu-beach</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-mean-fruit" />
            <h6 className="color-swatch--title">bg-mean-fruit</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-ripe-malin" />
            <h6 className="color-swatch--title">bg-ripe-malin</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-deep-blue" />
            <h6 className="color-swatch--title">bg-deep-blue</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-arielle-smile" />
            <h6 className="color-swatch--title">bg-arielle-smile</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-plum-plate" />
            <h6 className="color-swatch--title">bg-plum-plate</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-happy-fisher" />
            <h6 className="color-swatch--title">bg-happy-fisher</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-happy-itmeo" />
            <h6 className="color-swatch--title">bg-happy-itmeo</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-mixed-hopes" />
            <h6 className="color-swatch--title">bg-mixed-hopes</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-strong-bliss" />
            <h6 className="color-swatch--title">bg-strong-bliss</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-grow-early" />
            <h6 className="color-swatch--title">bg-grow-early</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-premium-dark" />
            <h6 className="color-swatch--title">bg-premium-dark</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-love-kiss" />
            <h6 className="color-swatch--title">bg-love-kiss</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-happy-green" />
            <h6 className="color-swatch--title">bg-happy-green</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-vicious-stance" />
            <h6 className="color-swatch--title">bg-vicious-stance</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-night-sky" />
            <h6 className="color-swatch--title">bg-night-sky</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-midnight-bloom" />
            <h6 className="color-swatch--title">bg-midnight-bloom</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-slick-carbon" />
            <h6 className="color-swatch--title">bg-slick-carbon</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-royal" />
            <h6 className="color-swatch--title">bg-royal</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-asteroid" />
            <h6 className="color-swatch--title">bg-asteroid</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-skim-blue" />
            <h6 className="color-swatch--title">bg-skim-blue</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-light-pure" />
            <h6 className="color-swatch--title">bg-light-pure</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-nice-redora" />
            <h6 className="color-swatch--title">bg-nice-redora</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-red-lights" />
            <h6 className="color-swatch--title">bg-red-lights</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-serious-blue" />
            <h6 className="color-swatch--title">bg-serious-blue</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-deep-sky" />
            <h6 className="color-swatch--title">bg-deep-sky</h6>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="color-swatch">
            <div className="color-swatch--bg bg-sunrise-purple" />
            <h6 className="color-swatch--title">bg-sunrise-purple</h6>
          </div>
        </Grid>
      </Grid>
    </Fragment>
  );
}
